/**
 * THE breakpoint ladder. Single source of truth for the whole frontend.
 * Spec: docs/specs_20260715_mobile_tablet_sweep.md §3
 *
 *   <= 699px       → phone
 *   700 - 1023px   → tablet   (every iPad portrait: 768 / 810 / 820 / 834)
 *   >= 1024px      → desktop  (incl. iPad landscape at 1180 — it has the width)
 *
 * The warehouse iPad is an 11" A16: 820x1180pt. Portrait (820) is therefore a
 * tablet, and that band is the one this ladder exists to make real.
 *
 * These values originated in the Tickets mobile work (spec D1,
 * docs/archive/202605/specs_20260515_tickets_mobile_responsive.md), whose author
 * had already diagnosed the core bug: a 768 boundary mis-classifies iPad
 * portrait as "the smallest desktop" instead of a real tablet. They replace the
 * ad-hoc 480 / 580 / 600 / 768 / 900 / 920 / 1000 / 1100 / 1200 / 1320
 * thresholds that had drifted across the CSS.
 *
 * CSS CANNOT IMPORT THIS. Custom properties are not allowed in `@media`
 * conditions, so stylesheets must repeat the literals. That duplication is
 * enforced, not trusted: styles/__tests__/breakpointLadder.test.js fails on any
 * `@media` value outside this ladder. Change a number here and that test tells
 * you every stylesheet that must follow.
 */

export const PHONE_MAX = 699
export const TABLET_MAX = 1023

/** Every width value the CSS is allowed to use in a @media condition. */
export const ALLOWED_MEDIA_WIDTHS = [PHONE_MAX, PHONE_MAX + 1, TABLET_MAX, TABLET_MAX + 1]

/**
 * Pure. Width in CSS px → band name.
 * @returns {'phone' | 'tablet' | 'desktop'}
 */
export function getBreakpoint(width) {
  if (width <= PHONE_MAX) return 'phone'
  if (width <= TABLET_MAX) return 'tablet'
  return 'desktop'
}
